// PagesLogin.js
import React, { useEffect, useContext, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { isAuthenticated } from "./auth";
import { AuthContext } from "./AuthContext"; // Importa el contexto

function PagesLogin() {
  const navigate = useNavigate();
  const context = useContext(AppSettings);
  const { setUserModules } = useContext(AuthContext); // Usa el contexto
  const [redirect, setRedirect] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentClass("");
    };
  }, [context]);

  // Redirigir si ya está autenticado
  useEffect(() => {
    if (isAuthenticated()) {
      navigate("/analytics", { replace: true });
    }
  }, [navigate]);

  async function handleSubmit(event) {
    event.preventDefault();

    // Al copiar y pegar el usuario/contraseña se suelen ir espacios al inicio
    // o al final; se quitan antes de enviar para que no falle el login.
    const correoLimpio = email.trim();
    const contrasenaLimpia = password.trim();

    setEmail(correoLimpio);
    setPassword(contrasenaLimpia);

    if (!correoLimpio || !contrasenaLimpia) {
      alert("Escribe tu correo y contraseña.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.checkmark.mx/financiamiento/login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            access_token:
              "1MhYphhrGUbgbdRy7cyYFGQlXS7tAi6ooUoptkHQbOm9GcsKiZM7uMF1MERxwMWq30I7Y3",
            correo: correoLimpio,
            contrasena: contrasenaLimpia,
          }),
        },
      );

      const data = await response.json();
      console.log("Datos:", data);

      if (response.ok && data.data) {
        const accessToken = data.data.access_token;
        const userEmail = data.data.usuario.correo;
        const userName = data.data.usuario.nombre;
        const userId = data.data.usuario.id;
        const agencias = data.data.usuario.agencias;
        const modulos = data.data.usuario.modulos;

        // Guarda la información del usuario en localStorage
        localStorage.setItem("userEmail", userEmail);
        localStorage.setItem("userName", userName);
        localStorage.setItem("userId", userId);
        localStorage.setItem("agencias", agencias);
        localStorage.setItem("modulos", JSON.stringify(modulos)); // Guarda los módulos en localStorage

        // Actualiza el contexto con los módulos del usuario
        setUserModules(modulos);
        console.log("Módulos de usuario después de iniciar sesión:", modulos);
        console.log(
          "Módulos guardados en localStorage:",
          JSON.parse(localStorage.getItem("modulos")),
        ); // Verifica que se guarden correctamente
        // Validar el token
        // const tokenResponse = await fetch(
        //   "https://api.checkmark.mx/financiamiento/validate-token",
        //   {
        //     method: "POST",
        //     headers: {
        //       "Content-Type": "application/json",
        //     },
        //     body: JSON.stringify({
        //       access_token: accessToken,
        //     }),
        //   }
        // );

        // const tokenData = await tokenResponse.json();

        // if (tokenResponse.ok && tokenData.data) {
        localStorage.setItem("accessToken", accessToken);
        setRedirect(true); // Cambia el estado de redirección
        // } else {
        //   setRedirect(false);
        // }
      } else {
        setRedirect(false);
        alert(data.message || "Error en el inicio de sesión");
      }
    } catch (error) {
      console.error("Error:", error);
      setRedirect(false);
      alert("Ocurrió un error al intentar iniciar sesión");
    }
  }

  // Redirigir a /analytics si se establece el estado de redirección
  useEffect(() => {
    if (redirect) {
      navigate("/analytics", { replace: true });
    }
  }, [redirect, navigate]);

  return (
    <div className="login">
      <div>
        <div className="mb-4 text-center">
          <img
            src="/assets/img/babilonia2.png"
            alt="Babilonia"
            style={{
              maxWidth: "100px",
              width: "100%",
              height: "auto",
            }}
          />
        </div>

        <div className="login-content">
          <form onSubmit={handleSubmit}>
            <h1 className="text-center">Iniciar sesión</h1>
            <div className="text-body black-text text-center mb-5">
              Para tu protección, por favor verifica tu identidad.
            </div>
            <div className="mb-4">
              <label className="form-label black-text" htmlFor="email">
                Dirección de correo electrónico
              </label>
              <input
                type="text"
                className="form-control form-control-lg fs-14px"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlur={(e) => setEmail(e.target.value.trim())}
                placeholder="usuario@dirección.com"
                required
              />
            </div>
            <div className="mb-4">
              <div className="d-flex">
                <label className="form-label black-text" htmlFor="password">
                  Contraseña
                </label>
              </div>
              <input
                type="password"
                className="form-control form-control-lg fs-14px"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Ingresa tu contraseña"
                required
              />
            </div>
            <button
              type="submit"
              className="btn btn-theme btn-lg d-block w-100 mb-3"
            >
              INICIAR SESIÓN
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PagesLogin;